//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherAvailabilityInputItem } from './TeacherAvailabilityInputItem';
import { BatchTeacherAvailabilityUpdateItem } from './BatchTeacherAvailabilityUpdateItem';

export class BatchTeacherAvailabilityItems extends ItemBase {
    InputItems: TeacherAvailabilityInputItem[] = [];
    UpdateItems: BatchTeacherAvailabilityUpdateItem[] = [];
    DeleteIDs: string[] = [];

    constructor(initializer?: Partial<BatchTeacherAvailabilityItems>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BatchTeacherAvailabilityItems";
}
